module.exports = __webpack_public_path__ + "static/media/PM105.f416c0d3.png";